import { Injectable } from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';

@Injectable({
  providedIn: 'root',
})
export class GoogleMapsService {
  private loader: Loader;

  constructor() {
    this.loader = new Loader({
      apiKey: 'AIzaSyCVyjO-cVe3gKb_8FWrszGsX8UkNrpZWO8',
      libraries: ['places'],
    });
  }

  load(): Promise<typeof google> {
    return this.loader.load();
  }
}